import React from 'react';

function ProductsSection({
    filteredAndSortedImages,
    filterVendorName,
    setFilterVendorName,
    sortOrder,
    setSortOrder,
    API_BASE_URL
}) {
    return (
        <div className="mb-8 p-4 border rounded-md bg-white shadow-sm">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">All Products Details</h2>
            <p className="text-gray-600 mb-4">This section displays all uploaded products with their detailed information.</p>

            {/* Filter and Sort Controls */}
            <div className="flex flex-col md:flex-row gap-4 mb-4 items-center">
                {/* Vendor Filter */}
                <div className="flex-1 w-full">
                    <label htmlFor="productsVendorFilter" className="block text-sm font-medium text-gray-700 mb-1">
                        Filter by Vendor:
                    </label>
                    <input
                        type="text"
                        id="productsVendorFilter"
                        value={filterVendorName}
                        onChange={(e) => setFilterVendorName(e.target.value)}
                        placeholder="Enter vendor name"
                        className="p-2 border border-gray-300 rounded-md w-full focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                {/* Sorting Options */}
                <div className="flex-1 w-full">
                    <label htmlFor="productsSortOrder" className="block text-sm font-medium text-gray-700 mb-1">
                        Sort By:
                    </label>
                    <select
                        id="productsSortOrder"
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        className="p-2 border border-gray-300 rounded-md w-full focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="none">Default (Latest Uploads)</option>
                        <option value="avg_desc">Average Rating (High to Low)</option>
                        <option value="avg_asc">Average Rating (Low to High)</option>
                        <option value="reviews_desc">Total Reviews (High to Low)</option>
                    </select>
                </div>
            </div>

            {filteredAndSortedImages.length === 0 ? (
                <p className="text-gray-600">No products to display based on current filters.</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Preview
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Product Name
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Vendor
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Avg. Rating
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Total Reviews
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Uploaded By
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Upload Date
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {filteredAndSortedImages.map((image) => (
                                <tr key={image.unique_image_id}>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {image.imageUrl && (
                                            <img src={image.imageUrl} alt={image.filename} className="h-12 w-12 object-cover rounded-md" />
                                        )}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{image.filename}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{image.vendor_name || 'N/A'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-blue-700">
                                        {image.averageScore}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {image.totalReviews}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-mono">
                                        {image.uploaded_by}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {image.uploaded_at ? new Date(image.uploaded_at).toLocaleString() : 'N/A'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default ProductsSection;
